import localeEn from './locales/en'
import localeAr from './locales/ar'
localStorage.getItem('NG_TRANSLATE_LANG_KEY') === 'en' ? import('@/app/shared/components/health-questionnaire/theme/health-questionnaire.scss') : import('@/app/shared/components/health-questionnaire/theme/health-questionnaire-rtl.scss');
import patientBanner from "@/app/physician-portal/physician-desktop/shared/patient-banner-new/patientBanner.vue";
import { EventBus  } from '@/app/shared/services/event-bus.js';
import { getGenderEnums, getSaveResultEnums, getAllergicStatusEnums, getWizardEnums, getYesNoEnums } from '@/app/shared/components/health-questionnaire/config/health-questionnaire-enums.js';
import { ValidationObserver, extend } from 'vee-validate';
import { max_value, min_value } from 'vee-validate/dist/rules';
import { getmainHealthQuestionnaireScreenEnums, geSmokingStatus } from '@/app/shared/components/health-questionnaire/config/health-questionnaire-enums.js'; //getDateList
import { screeningService } from '@/app/shared/components/health-questionnaire/services/screening-service';
import { showPopupNotification } from '@/app/shared/grid-functionality/grid-functionality.js';
import Loader from '@/app/shared/layouts/components/loader/loader.vue';
import { medicalhistoryService } from '@/app/shared/components/health-questionnaire/services/medicalHistory-service.js';



import $ from "jquery";
export default {
    name: "health-questionnaire",
    props: ["wizard", "title", "patientObj", "externalService", "ParentFlagName"],
    data() {
        return {
            isLoading: false,
            hideNotification: 5000,
            isEnLang: localStorage.getItem('NG_TRANSLATE_LANG_KEY') === 'en',
            observer: null,
            patientDataObj: "test",
            parentFlagName: this.ParentFlagName,
            tabs: [],//this.wizard.tabs,
            data: {},// this.wizard.data,
            tabFlags: {}, // filled in created ()   {compName_1: { ifFlag: false, showFlag: false, hasError:false },compName_2: { ifFlag: false, showFlag: false }} then attach v-if and v-show in vue file
            formData: {
                AllergyData: {
                    AllergyData: {},
                    DeletedAllergy:[]
                },
                socialFormData: {},
                familyFormData: {},
                PastMedicalHistoryData: {},
                //AllergyData: {},
                getObsGynData: {},
                getCurrentSymptomsData: {},
                SurgicalFormData: {},
                MedicationHistoryData: {},
            },
            lookupFlags:{
                socialHistory: {},
                familyHistory: {},
                PastMedicalHistory: {},
                Allergies: {},
                ObsGyn: {},
                CurrentSymptoms: {},
                SurgicalHistory: {},
                MedicationHistory: {},
        },
            hasAnyInvalidData: false,
            visitID: this.patientObj.visitMgtObj.VisitID,
            patientID: this.patientObj.patientObj.ID,
            getGenderEnums: getGenderEnums(),
            geSmokingStatus: geSmokingStatus(),
            getSaveResultEnums: getSaveResultEnums(),
            getYesNoEnums: getYesNoEnums(),
            getAllergicStatusEnums: getAllergicStatusEnums(),
            patientAgeY: this.patientObj.patientObj.AgeEn.split(" ")[0],
            patientAgeMD: (this.patientObj.patientObj.AgeEn.indexOf("M") != -1 || this.patientObj.patientObj.AgeEn.indexOf("D") != -1) ? true : false,
            hasAllergies: this.patientObj.patientObj.IsAllergiesSpecified,
            // patientId: this.patientObj.patientObj.ID,
            patientData: this.patientObj.patientObj,
            showOBS:true

        }
    },
    methods: {
        calculatDate() {
            //debugger
            let DOB = new Date(this.patientData.DateOfBirth)
            let today = new Date()
            const diffTime = Math.abs(today - DOB);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            this.showOBS = diffDays >= 4383 ? true : false
        },
        showPopupNotification,
        toogleNext() {
            this.toogle(true)
        },
        tooglePrevious() {
            this.toogle(false)
        },
        toogle(direction) {
            let keys = Object.keys(this.tabFlags);
            let selectedTabName
            let followngItemPosition = direction ? 1 : -1;

            for (let compFlag in this.tabFlags) {
                if (this.tabFlags[compFlag].showFlag) {
                    selectedTabName = compFlag;
                    break;
                }
            }
            let selectedTab = keys.find(item => item == selectedTabName)
            let selectedTabIndex = keys.indexOf(selectedTab);
            if (keys[selectedTabIndex + followngItemPosition] != undefined) {
                let currentTab = keys[selectedTabIndex];
                let followngTab = keys[selectedTabIndex + followngItemPosition];
                this.tabFlags[currentTab].showFlag = false
                this.tabFlags[followngTab].showFlag = true
                this.tabFlags[followngTab].ifFlag = true
            }
        },
        checkActive(compName) {
            return this.tabFlags[compName] ? this.tabFlags[compName].showFlag : null;
        },
        checkError(compName) {
            return this.tabFlags[compName]? this.tabFlags[compName].hasError : null
        },
        changetab(compName) {
            for (let compFlag in this.tabFlags) {
                this.tabFlags[compFlag].showFlag = false
            }
            this.tabFlags[compName].ifFlag = true
            this.tabFlags[compName].showFlag = true
        },
        setPatientBanner() {
            $('.health-questionnaire #patient-banner').addClass('patient-banner-fixed');
            $('.health-questionnaire #patient-banner').removeClass('patient-banner-main');
        
            let patientOb = {
                PatientID: this.patientObj.patientObj.ID,
                VisitClassificationID: this.patientObj.visitMgtObj.VisitClassificationID,
                VisitID: this.patientObj.visitMgtObj.VisitID,
                showPatientBanner: true
            }
            this.$refs.initPatientBanner.init(patientOb);
        },
        // get lookups flag
        getPatientVisitLookUpFlag(patientObj) {
            this.patientDataObj = patientObj;
        },
        getSocialHistoryLookUpFlag(data) {
            this.lookupFlags.socialHistory = data;
        },
        getFamilyHistoryLookUpFlag(data) {
            this.lookupFlags.familyHistory = data;
        },
        getPastMedicalHistoryLookUpFlag(data) {
            this.lookupFlags.PastMedicalHistory = data;
        },
        getAllergyLookUpFlag(data) {
            this.lookupFlags.Allergies = data;
        },
        getObsGynLookUpFlag(data) {
            this.lookupFlags.ObsGyn = data;
        },
        getCurrentSymptomsLookUpFlag(data) {
            this.lookupFlags.CurrentSymptoms = data;
        },
        getSurgicalHistoryLookUpFlag(data) {
            this.lookupFlags.SurgicalHistory = data;
        },
        getMedicationHistoryLookUpFlag(data) {
            debugger
            this.lookupFlags.MedicationHistory = data;
        },
        // get data
        getSocialHistoryData(data) {
            this.formData.socialFormData = data;
        },
        getFamilyHistoryData(data) {
            this.formData.familyFormData = data;
        },
        getPastMedicalHistoryData(data) {
            this.formData.PastMedicalHistoryData = data;
        },
        getAllergyData(data) {
            debugger
            this.formData.AllergyData.AllergyData = data.AllergyData;
            if (data.DeletedAllergy.length > 0)
                this.formData.AllergyData.DeletedAllergy.push(data.DeletedAllergy[0])
        },
        getObsGynData(data) {
            this.formData.getObsGynData = data;
        },
        getCurrentSymptomsData(data) {
            this.formData.getCurrentSymptomsData = data;
        },
        getSurgicalHistoryData(data) {
            this.formData.SurgicalFormData = data;
        },
        getMedicationHistoryData(data) {
            debugger
            this.formData.MedicationHistoryData = data;
        },

        getFireValidation() {
            setTimeout(() => {
                this.$refs.observerr.validate()

            }, 100);
        },
        checkBorderError(type) {
            let keys = Object.keys(this.tabFlags);
            keys.map(compName => {
                let error = $(`#${compName}`).find(".border-danger").length == 0 ? false : true;
                let validation = $(`#${compName}`).find(".k-state-default.k-invalid").length == 0 ? false : true;
                if (error || validation) {
                    this.tabFlags[compName].hasError = true;
                    this.hasAnyInvalidData = true
                } else {
                    if (!this.tabFlags[compName].ifFlag && (type == getmainHealthQuestionnaireScreenEnums().submit || this.tabFlags[compName].triggerValidation)) {
                        this.tabFlags[compName].hasRequired ? this.tabFlags[compName].hasError = true : null;
                        this.tabFlags[compName].triggerValidation = true;
                    } else if (this.tabFlags[compName].ifFlag) {

                        this.tabFlags[compName].hasError = false;

                    }

                }
            })
        },
        setScrollBar() {
            let height = document.querySelector('.body-left-hand-side').offsetHeight;
            if (height != 0) {
                document.querySelector('.body-right-hand-side').style.height = height + "px"

            } else {
                document.querySelector('.body-right-hand-side').style.height = height + "100%"

            }
        },
        creatingObserver() {
            this.observer = new MutationObserver(mutationRecords => {
                console.log(mutationRecords)
                this.checkBorderError()
                this.setScrollBar()
            });
            let targetNode = document.getElementById("observer-wrapper");
            if (targetNode) {
                this.observer.observe(targetNode, {
                    childList: true, // observe direct children
                    subtree: true, // lower descendants too
                    characterDataOldValue: true, // pass old data to callback
                });
            }
        },
        getCustTooltipTilte(e) {
            let elem = e.target[0];
           if (elem.classList.contains("save-btn-fake")) {
                return this.$i18n.t('HealthQuestionnaire.AllTabOpen');
            }
        },
        async submit() {
            debugger
            console.log("BigSaveObj")
            console.log(this.formData)
            console.log(this.patientObj)
            console.log(this.patientObj.visitMgtObj)
            this.hasAnyInvalidData = false;
            const isValid = await this.$refs.observerr.validate();
            this.checkBorderError(getmainHealthQuestionnaireScreenEnums().submit)
            if (isValid && !this.hasAnyInvalidData) {
                var socialObj = {
                    "MaritalStatusId": parseInt(this.formData.socialFormData.MaritalStatus),
                    "ModeId": this.formData.socialFormData.Mode,
                    "NumberOfPackYearsResult": parseFloat(this.formData.socialFormData.SmokingHx),//this.formData.socialFormData.NumberOfCigarettesPerDay,
                    "SmokingStatusId": this.formData.socialFormData.SmokingStatus,
                    "SmokingCigarettesPerDay": parseInt(this.formData.socialFormData.NumberOfCigarettesPerDay),// parseInt(this.formData.socialFormData.StoppedCigarettesPerDay),
                    "SmokingYears": parseInt(this.formData.socialFormData.NumberOfYears),
                    "StoppedSmokingCigarettesPerDay": parseInt(this.formData.socialFormData.StoppedCigarettesPerDay),
                    "StoppedSinceValue": parseInt(this.formData.socialFormData.StoppedSince),
                    "OccupationId": this.formData.socialFormData.Occupation,
                    "AlcoholUseId": this.formData.socialFormData.AlcoholUse,
                    "CaffieneDoseId": this.formData.socialFormData.CaffeineUse,
                    "DurationId": this.formData.socialFormData.SmokingStatus == geSmokingStatus().ExSmoker ? this.formData.socialFormData.DurationDDL : null,
                    "IsHaveChildren": this.formData.socialFormData.HasChildren == getYesNoEnums().Yes ? true : false,
                    "NoOfChildren": this.formData.socialFormData.NoOfChildren 
                }
                if (this.parentFlagName == getWizardEnums().MedicalHistory) {
                    //socialObj.NoOfChildren = this.formData.socialFormData.NoOfChildren
                    socialObj.SavedFromMedHistory = true;
                }
                var familyHistoryObj = {
                    "FatherMedicalHistory": this.formData.familyFormData.FatherMedicalHistory,
                    "MotherMedicalHistory": this.formData.familyFormData.MotherMedicalHistory,
                    "ChildrenMedicalHistory": this.formData.familyFormData.ChildrenMedicalHistory,
                    "SiblingsMedicalHistory": this.formData.familyFormData.SiblingsMedicalHistory,
                    "GrandParentsMedicalHistory": this.formData.familyFormData.GrandparentMedicalHistory
                }
                var surgeryHistoryObj = [];
                if (this.formData.SurgicalFormData.SurgicalHistory && this.formData.SurgicalFormData.SurgicalHistory.length > 0) {
                    for (var i = 0; i < this.formData.SurgicalFormData.SurgicalHistory.length; i++) {
                        if (this.formData.SurgicalFormData.SurgicalHistory[i].isHistorical == true) { 
                        var surgericalObj = {
                            "SurgeryId": this.formData.SurgicalFormData.SurgicalHistory[i].surgeryID,
                            "SurgeryArName": this.formData.SurgicalFormData.SurgicalHistory[i].surgeryArName,
                            "SurgeryEnName": this.formData.SurgicalFormData.SurgicalHistory[i].surgeryEnName,
                            "SurgeryCode": this.formData.SurgicalFormData.SurgicalHistory[i].surgeryCode,
                            "Date": new Date(this.formData.SurgicalFormData.SurgicalHistory[i].date).toLocaleString()
                        }
                        surgeryHistoryObj.push(surgericalObj);
                    }
                    }
                }
              
                if (this.parentFlagName == getWizardEnums().Screening) {
                    debugger
                    var pastMedicalObj = [];
                    if (this.formData.PastMedicalHistoryData.PastMedicalHistory && this.formData.PastMedicalHistoryData.PastMedicalHistory.length > 0) {
                        for (var j = 0; j < this.formData.PastMedicalHistoryData.PastMedicalHistory.length; j++) {
                            if (this.formData.PastMedicalHistoryData.PastMedicalHistory[j].IsThisVisit == undefined) {
                                var medObj = {
                                    "ICDDiagnoseCode": this.formData.PastMedicalHistoryData.PastMedicalHistory[j].ICDDiagnoseCode,
                                    "ICDDiagnoseName": this.formData.PastMedicalHistoryData.PastMedicalHistory[j].ICDDiagnoseText,
                                    "DiagnoseID": parseInt(this.formData.PastMedicalHistoryData.PastMedicalHistory[j].DiagnoseID),
                                    "StartingDate": this.formData.PastMedicalHistoryData.PastMedicalHistory[j].StartingDate == undefined ? null : new Date(this.formData.PastMedicalHistoryData.PastMedicalHistory[j].StartingDate).toLocaleString()
                                }
                                pastMedicalObj.push(medObj);
                            }
                        }
                    }
                    var DeletedMedicalObj = [];
                    if (this.formData.PastMedicalHistoryData.DeletedMedicalHistory && this.formData.PastMedicalHistoryData.DeletedMedicalHistory.length > 0) {
                        for (var b = 0; b < this.formData.PastMedicalHistoryData.DeletedMedicalHistory.length; b++) {
                                var DeletedMedObj = {
                                    "modifiedTS": this.formData.PastMedicalHistoryData.DeletedMedicalHistory[b].ModifiedTS,
                                    "problemDetailsID": this.formData.PastMedicalHistoryData.DeletedMedicalHistory[b].ProblemCardDetailsID,
                            }
                            if (DeletedMedObj.modifiedTS != undefined && DeletedMedObj.problemDetailsID != undefined) {
                                DeletedMedicalObj.push(DeletedMedObj);
                            }
                           
                        }
                    }
                
                    var allergyObj = {};
                    if (this.formData.AllergyData) {
                        allergyObj.AllergyStatusId = this.formData.AllergyData.AllergyData.HasAllergy == undefined ? getAllergicStatusEnums().PatientNotAddedAllergic : this.formData.AllergyData.AllergyData.HasAllergy;
                        allergyObj.AllergyList = [];
                        allergyObj.DeletedAllergyList = [];
                        if (this.formData.AllergyData.AllergyData.allergyGridData != undefined && this.formData.AllergyData.AllergyData.allergyGridData.length > 0) {
                            for (var k = 0; k < this.formData.AllergyData.AllergyData.allergyGridData.length; k++) {
                                if (this.formData.AllergyData.AllergyData.allergyGridData[k].uniqId >= 0) {
                                    var AllergyObj = {
                                        "AllergyId": this.formData.AllergyData.AllergyData.allergyGridData[k].AllergiesID,
                                        "AllergyTypeArName": this.formData.AllergyData.AllergyData.allergyGridData[k].AllergiesTypeArName,
                                        "AllergyTypeEnName": this.formData.AllergyData.AllergyData.allergyGridData[k].AllergiesTypeEnName,
                                        "AllergyTypeId": this.formData.AllergyData.AllergyData.allergyGridData[k].AllergiesTypeID,
                                        "AllergyArName": this.formData.AllergyData.AllergyData.allergyGridData[k].AllergyArName,
                                        "AllergyEnName": this.formData.AllergyData.AllergyData.allergyGridData[k].AllergyEnName,
                                        "SeverityId": this.formData.AllergyData.AllergyData.allergyGridData[k].SeverityID == 0 ? null : this.formData.AllergyData.AllergyData.allergyGridData[k].SeverityID ,
                                        "SeverityEnName": this.formData.AllergyData.AllergyData.allergyGridData[k].SeverityEnName,
                                        "SeverityArName": this.formData.AllergyData.AllergyData.allergyGridData[k].SeverityArName
                                    }
                                    allergyObj.AllergyList.push(AllergyObj);
                                }
                            }
                        }

                        if (this.formData.AllergyData.DeletedAllergy != undefined && this.formData.AllergyData.DeletedAllergy.length > 0) {
                            for (var f = 0; f < this.formData.AllergyData.DeletedAllergy.length; f++) {
                                if (!(this.formData.AllergyData.DeletedAllergy[f].uniqId >= 0)) {
                                var DeletedAllergyObj = {
                                    "AllergyId": this.formData.AllergyData.DeletedAllergy[f].AllergiesID,
                                    "AllergyTypeArName": this.formData.AllergyData.DeletedAllergy[f].AllergiesTypeArName,
                                    "AllergyTypeEnName": this.formData.AllergyData.DeletedAllergy[f].AllergiesTypeEnName,
                                    "AllergyTypeId": this.formData.AllergyData.DeletedAllergy[f].AllergiesTypeID,
                                    "AllergyArName": this.formData.AllergyData.DeletedAllergy[f].AllergyArName,
                                    "AllergyEnName": this.formData.AllergyData.DeletedAllergy[f].AllergyEnName,
                                    "SeverityId": this.formData.AllergyData.DeletedAllergy[f].SeverityID,
                                    "SeverityEnName": this.formData.AllergyData.DeletedAllergy[f].SeverityEnName,
                                    "SeverityArName": this.formData.AllergyData.DeletedAllergy[f].SeverityArName
                                }
                                allergyObj.DeletedAllergyList.push(DeletedAllergyObj);
                                 }
                            }
                        }

                    }

                var CurrentSymptomsObj = {};
                if (this.formData.getCurrentSymptomsData) {
                    CurrentSymptomsObj.ExcessiveTirednessState = this.formData.getCurrentSymptomsData.UnusualTiredness == getYesNoEnums().Yes ? true : false;
                    CurrentSymptomsObj.ExcessiveTierdnessScale = this.formData.getCurrentSymptomsData.UnusualTirednessValue;
                    CurrentSymptomsObj.BodyWeightStatus = this.formData.getCurrentSymptomsData.BodyweightStable == getYesNoEnums().Yes ? true : false;
                    CurrentSymptomsObj.WeightGain = this.formData.getCurrentSymptomsData.WeightGain;
                    CurrentSymptomsObj.WeightLoss = this.formData.getCurrentSymptomsData.WeightLoss;
                    CurrentSymptomsObj.AppetiteState = this.formData.getCurrentSymptomsData.AppetiteStable == getYesNoEnums().Yes ? true : false;
                    CurrentSymptomsObj.SleepingState = this.formData.getCurrentSymptomsData.TroubleSleeping == getYesNoEnums().Yes ? true : false;
                    CurrentSymptomsObj.SexualProblemState = this.formData.getCurrentSymptomsData.SexualProblems == getYesNoEnums().Yes ? true : false;
                    CurrentSymptomsObj.AccidentsInThePast = this.formData.getCurrentSymptomsData.PastAccidents == getYesNoEnums().Yes ? true : false;
                    CurrentSymptomsObj.TroubleInDoingActivityState = this.formData.getCurrentSymptomsData.TroubleActivities == getYesNoEnums().Yes ? true : false;
                    CurrentSymptomsObj.PainState = this.formData.getCurrentSymptomsData.HavePain == getYesNoEnums().Yes ? true : false;
                    CurrentSymptomsObj.ConcentratingState = this.formData.getCurrentSymptomsData.DifficultiesConcentrating == getYesNoEnums().Yes ? true : false;
                    }
                }
                debugger
                var MedicationList = [];
                if (this.formData.MedicationHistoryData.formData != undefined && this.formData.MedicationHistoryData.formData.length > 0) {
                    for (var m = 0; m < this.formData.MedicationHistoryData.formData.length; m++) {
                        debugger;
                        var MedicationObj = {
                            "MedicationNameId": this.formData.MedicationHistoryData.formData[m].medicationNameId,
                            "MedicationNameAr": this.formData.MedicationHistoryData.formData[m].medicationNameAr,
                            "MedicationNameEn": this.formData.MedicationHistoryData.formData[m].medicationNameEn,
                            "Dose": this.formData.MedicationHistoryData.formData[m].Dose,
                            "DoseUOMId": this.formData.MedicationHistoryData.formData[m].DoseUOMid == null ? this.formData.MedicationHistoryData.formData[m].doseUOMId : this.formData.MedicationHistoryData.formData[m].DoseUOMid,
                            "DoseNameEn": this.formData.MedicationHistoryData.formData[m].doseNameEn,
                            "DoseNameAr": this.formData.MedicationHistoryData.formData[m].doseNameAr,
                            "FrequencyQty": this.formData.MedicationHistoryData.formData[m].Every,
                            "FrequencyTimeUnitID": this.formData.MedicationHistoryData.formData[m].EveryUOMid,
                            "DurationQty": this.formData.MedicationHistoryData.formData[m].For,
                            "DurationTimeUnitId": this.formData.MedicationHistoryData.formData[m].ForUOMid,
                            "IsChronic": this.formData.MedicationHistoryData.formData[m].IsChronic == "" ? false : true,
                            "LastDoseDate": new Date(this.formData.MedicationHistoryData.formData[m].LastDose).toLocaleString(),
                            "StatusId": this.formData.MedicationHistoryData.formData[m].statusId

                        }
                        MedicationList.push(MedicationObj);

                    }

                }
                var ObsGynHistoryObj = {};
                if (this.patientObj.patientObj.GenderID == getGenderEnums().Female && (this.patientAgeY > 12 || (this.patientAgeY == 12 && this.patientAgeMD))) {
                    if (this.formData.getObsGynData) {
                        ObsGynHistoryObj.NumberOfDeliveries = this.formData.getObsGynData.NumberOfDeliveries;
                        ObsGynHistoryObj.DateOfLastMensturation = (this.formData.getObsGynData.DateOfLastMenstruation == "" || this.formData.getObsGynData.DateOfLastMenstruation == null) ? null : new Date(this.formData.getObsGynData.DateOfLastMenstruation).toLocaleString();
                        ObsGynHistoryObj.BleedingState = this.formData.getObsGynData.BleedingBetweenMenstruation == getYesNoEnums().Yes ? true : false;
                        ObsGynHistoryObj.CervicalSmearState = this.formData.getObsGynData.HadCervicalSmear == getYesNoEnums().Yes ? true : false;
                        ObsGynHistoryObj.CervicalSmearResult = ObsGynHistoryObj.CervicalSmearState ?(this.formData.getObsGynData.CervicalSmearResults == getYesNoEnums().Yes ? true : false):null;
                        ObsGynHistoryObj.RecallTime = parseInt(this.formData.getObsGynData.Recalltime);
                        ObsGynHistoryObj.ContraceptionState = this.formData.getObsGynData.IsContraception == getYesNoEnums().Yes ? true : false;
                        //ObsGynHistoryObj.ContraceptionState = 1;
                        ObsGynHistoryObj.GynaecologicalProblemState = this.formData.getObsGynData.HadGynecologicalProblem == getYesNoEnums().Yes ? true : false;
                        ObsGynHistoryObj.GynaecologicalProblem = this.formData.getObsGynData.GynecologicalProblemList;
                        // ObsGynHistoryObj.GynaecologicalProblem = "sssss";
                        ObsGynHistoryObj.ContraceptionList = this.formData.getObsGynData.ContraceptionList;
                            ObsGynHistoryObj.PregnancyComplications = this.formData.getObsGynData.PregnancyComplications;
                            ObsGynHistoryObj.livingChildren = this.formData.getObsGynData.LivingChildren;
                            ObsGynHistoryObj.pregnancyTimes = this.formData.getObsGynData.PregnancyTimes;
                            ObsGynHistoryObj.abortionTimes = this.formData.getObsGynData.AbortionTimes;
                            ObsGynHistoryObj.miscarriageTimes = this.formData.getObsGynData.MiscarriageTimes;
                            ObsGynHistoryObj.previousDeliveryHistory = this.formData.getObsGynData.PreviousDeliveryHistory;

                    }
                }
                console.log(socialObj)
                console.log(ObsGynHistoryObj)

              
                if (this.parentFlagName == getWizardEnums().Screening) {
                    var questionnaireObj = {};
                    if (this.patientObj.patientObj.GenderID == getGenderEnums().Female && this.showOBS) {
                         questionnaireObj = {
                            "PatientId": this.patientID,
                            "PatientNameAr": this.patientData.PatientArName,
                            "PatientNameEn": this.patientData.PatientEnName,
                            "VisitId": this.visitID,
                            "VisitDate": this.patientObj.visitMgtObj.PerformingDate,
                            "VisitClassificationId": this.patientObj.visitMgtObj.VisitClassificationID,
                             "socialHistory": this.tabFlags["socialHistory"] && this.tabFlags["socialHistory"].ifFlag ? socialObj : null,
                             "familyHistory": this.tabFlags["familyHistory"] && this.tabFlags["familyHistory"].ifFlag ? familyHistoryObj : null ,
                             "SurgicalHistory": this.tabFlags["SurgicalHistory"] && this.tabFlags["SurgicalHistory"].ifFlag ? surgeryHistoryObj : null ,
                             "PastMedicalHistory": this.tabFlags["PastMedicalHistory"] && this.tabFlags["PastMedicalHistory"].ifFlag ? pastMedicalObj : null ,
                             "Allergies": this.tabFlags["Allergies"] && this.tabFlags["Allergies"].ifFlag ? allergyObj : null ,
                             "MedicationHistory": this.tabFlags["MedicationHistory"] && this.tabFlags["MedicationHistory"].ifFlag ? MedicationList : null ,
                             "CurrentSymptoms": this.tabFlags["CurrentSymptoms"] && this.tabFlags["CurrentSymptoms"].ifFlag ? CurrentSymptomsObj : null ,
                             "DeletedPastMedicalHistory": this.tabFlags["PastMedicalHistory"] && this.tabFlags["PastMedicalHistory"].ifFlag ? DeletedMedicalObj : null,
                             "ObsGyn": this.tabFlags["ObsGyn"] && this.tabFlags["ObsGyn"].ifFlag ? ObsGynHistoryObj : null,
                        }
                    }
                    else {
                         questionnaireObj = {
                            "PatientId": this.patientID,
                            "PatientNameAr": this.patientData.PatientArName,
                            "PatientNameEn": this.patientData.PatientEnName,
                            "VisitId": this.visitID,
                             "VisitClassificationId": this.patientObj.visitMgtObj.VisitClassificationID,
                             "VisitClassificationArName": this.patientObj.visitMgtObj.VisitClassificationArName,
                             "VisitClassificationEnName": this.patientObj.visitMgtObj.VisitClassificationEnName,
                             "VisitDate": this.patientObj.visitMgtObj.PerformingDate,
                             "socialHistory": this.tabFlags["socialHistory"] && this.tabFlags["socialHistory"].ifFlag ? socialObj : null,
                             "familyHistory": this.tabFlags["familyHistory"] && this.tabFlags["familyHistory"].ifFlag ? familyHistoryObj : null,
                             "SurgicalHistory": this.tabFlags["SurgicalHistory"] && this.tabFlags["SurgicalHistory"].ifFlag ? surgeryHistoryObj : null,
                             "PastMedicalHistory": this.tabFlags["PastMedicalHistory"] && this.tabFlags["PastMedicalHistory"].ifFlag ? pastMedicalObj : null,
                             "Allergies": this.tabFlags["Allergies"] && this.tabFlags["Allergies"].ifFlag ? allergyObj : null,
                             "MedicationHistory": this.tabFlags["MedicationHistory"] && this.tabFlags["MedicationHistory"].ifFlag ? MedicationList : null,
                             "CurrentSymptoms": this.tabFlags["CurrentSymptoms"] && this.tabFlags["CurrentSymptoms"].ifFlag ? CurrentSymptomsObj : null,
                             "DeletedPastMedicalHistory": this.tabFlags["PastMedicalHistory"] && this.tabFlags["PastMedicalHistory"].ifFlag ? DeletedMedicalObj : null,

                        }
                    }
                
                    console.log(questionnaireObj)
                    this.isLoading = true;
                    screeningService.SavePatientQuestionnaire(questionnaireObj, (result) => {
                        debugger

                        if (result.data.statusId == getSaveResultEnums().Sucess) {
                            console.log(result)
                            this.isLoading = false;

                            this.showPopupNotification(this.$i18n.t('Common.Success'), this.$i18n.t('Common.SavedSuccessfully'), `success`)
                            this.$emit('closeModal');
                            EventBus.$emit("RefreshScreeningGrid");
                        }
                        else {
                            this.isLoading = false;

                            this.showPopupNotification(
                                `${this.$i18n.t("Common.Failure")}`,
                                `${this.$i18n.t("Common.SomethingWrong")}`,
                                "error"
                            );
                        }



                    },
                        (error) => {
                            this.isLoading = false;

                            if (error) {
                                this.showPopupNotification(
                                    `${this.$i18n.t("Common.Failure")}`,
                                    `${this.$i18n.t("Common.SomethingWrong")}`,
                                    "error"
                                );
                            }
                        });

                }

                //----------------------MedHistorySave-------------------------//
                if (this.parentFlagName == getWizardEnums().MedicalHistory) {
                    console.log("this.tabFlags")
                    console.log(this.tabFlags)
                    var MedHistoryObj = {
                        "PatientId": this.patientID,
                        "PatientNameAr": this.patientData.PatientArName,
                        "PatientNameEn": this.patientData.PatientEnName,
                        "VisitId": this.visitID,
                        "VisitClassificationId": this.patientObj.visitMgtObj.VisitClassificationID,
                        "socialHistory": this.tabFlags["socialHistory"] && this.tabFlags["socialHistory"].ifFlag ? socialObj : null,
                        "familyHistory": this.tabFlags["familyHistory"] && this.tabFlags["familyHistory"].ifFlag ? familyHistoryObj  : null,
                        "SurgicalHistory": this.tabFlags["SurgicalHistory"]&& this.tabFlags["SurgicalHistory"].ifFlag ? surgeryHistoryObj : null,
                        "MedicationHistory": this.tabFlags["MedicationHistory"]&& this.tabFlags["MedicationHistory"].ifFlag ? MedicationList : null,
                        "ObsGyn": this.showOBS && this.tabFlags["ObsGyn"]&& this.tabFlags["ObsGyn"].ifFlag ? ObsGynHistoryObj : null

                    }
                    console.log(MedHistoryObj)
                    this.isLoading = true;
                    medicalhistoryService.SetPatientMedicalHistory(MedHistoryObj, (result) => {
                        debugger

                        if (result.data.statusId == getSaveResultEnums().Sucess) {
                            console.log(result)
                            this.isLoading = false;

                            this.showPopupNotification(this.$i18n.t('Common.Success'), this.$i18n.t('Common.SavedSuccessfully'), `success`)
                            this.$emit('closeModal');
                            EventBus.$emit('RefreshHistoryPopOver');
                            EventBus.$emit("RefreshScreeningGrid");
                        }
                        else {
                            this.isLoading = false;

                            this.showPopupNotification(
                                `${this.$i18n.t("Common.Failure")}`,
                                `${this.$i18n.t("Common.SomethingWrong")}`,
                                "error"
                            );
                        }



                    },
                        (error) => {
                            this.isLoading = false;

                            if (error) {
                                this.showPopupNotification(
                                    `${this.$i18n.t("Common.Failure")}`,
                                    `${this.$i18n.t("Common.SomethingWrong")}`,
                                    "error"
                                );
                            }
                        });

                }
                //------------------------------------------------------------//

                if (this.externalService) {
                    this.$emit('getQuestionnaireDataAndSubmit', this.formData)
                    // this.$emit('closeModal')
                } else {
                    console.log("saved")
                    // this.$emit('closeModal')
                }
            }
            else {
                console.log("error")
            }
            console.log("lookUPs")
            console.log(this.lookupFlags)
        },
        //resolveDisableSave() {
        //    let keys = Object.keys(this.tabFlags);
        //    let unOpenedTab = []
        //    keys.map(item => {
        //        if (item == "ObsGyn") {
        //            if (this.patientObj.patientObj.GenderID == getGenderEnums().Female && (this.patientAgeY > 12 || (this.patientAgeY == 12 && this.patientAgeMD))) {
        //                !this.tabFlags[item].ifFlag ? unOpenedTab.push(item) : null

        //            } else {

        //                return false
        //            }
        //        } else {
        //            !this.tabFlags[item].ifFlag ? unOpenedTab.push(item) : null


        //        }
        //    })
        //    return unOpenedTab
        //},
        checkUnOpenedTab(compName) {
            if (this.parentFlagName == getWizardEnums().MedicalHistory) {
                return false
            } else {
                return !this.tabFlags[compName].ifFlag

            }
        },

    },
    computed: {
        NextBtnFlag() {
            let lastItem = Object.keys(this.tabFlags)[Object.keys(this.tabFlags).length - 1];
            return this.tabFlags[lastItem].showFlag ? true : false;
        },
        previousBtnFlag() {
            let firstItem = Object.keys(this.tabFlags)[0];
            return this.tabFlags[firstItem].showFlag
        },
        disableSave() {
            if (this.parentFlagName == getWizardEnums().MedicalHistory) {
                return false
            } else {

                let keys = Object.keys(this.tabFlags);
                let unOpenedTab = keys.find(item => !this.tabFlags[item].ifFlag)
                //let FormDatakeys = Object.keys(this.formData);
                let unloadedLookUps = keys.find(item => !this.lookupFlags[item].isLookUpLoaded)


                return unOpenedTab || unloadedLookUps ? true : false
            }
            //let check = this.resolveDisableSave();
            //return check[0] ? true : false;
        }
    },
    created() {
        document.body.classList.add("healthqesmodal");
        this.tabs = this.wizard.tabs
        this.data = this.wizard.data
        let createdFlags = {};
        //let requiredComponents = { socialHistory: true}
        let newtabs = [];
        for (let tab of this.tabs) {
            if (tab.compName == "ObsGyn") {
                if (this.patientObj.patientObj.GenderID == getGenderEnums().Female && (this.patientAgeY > 12 || (this.patientAgeY == 12 && this.patientAgeMD))) {
                    createdFlags[tab.compName] = { ifFlag: false, showFlag: false, hasError: false, triggerValidation: false };
                    newtabs.push(tab)

                } 
            } else {
                createdFlags[tab.compName] = { ifFlag: false, showFlag: false, hasError: false, triggerValidation: false };
                newtabs.push(tab)

            }
        }
        this.tabs = newtabs

        this.tabFlags = createdFlags;

        this.tabs.map(item => {
            item.validFlag = false
        })
        console.log(createdFlags)
        console.log(this.tabs)

    },
    mounted() {
        debugger
        this.setPatientBanner()
        this.setScrollBar()
        this.popupNotificationWidget = this.$refs.popupNotificationSave.kendoWidget();

        //display first screen
        this.changetab(this.tabs[0].compName)
        this.creatingObserver()
        this.calculatDate()
        extend('max_value', {
            ...max_value,
            message: (e) => {
                debugger
                if (e == "NumberOfDeliveries" || e == "LivingChildren" || e == "PregnancyTimes" || e == "AbortionTimes" || e == "MiscarriageTimes" || e == "NoOfChildren")
                    return this.$i18n.t('HealthQuestionnaire.ObsGyn.Max50')
                else
                    return this.$i18n.t('HealthQuestionnaire.ObsGyn.Max10')

            }
        });
        extend('min_value', {
            ...min_value,
            message: (e) => {
                debugger
                if (e == "NumberOfDeliveries")
                    return this.$i18n.t('HealthQuestionnaire.ObsGyn.Min0')
                else
                    return this.$i18n.t('HealthQuestionnaire.ObsGyn.Min1')

            }
        });



    },
    beforeDestroy() {
        document.body.classList.remove("healthqesmodal");
        if (this.observer) this.observer.disconnect()
        this.formData = {};
    },
    components: {
        patientBanner,
        ValidationObserver,
        Loader,
        FamilyHistory: () => import("./family-history/family-history.vue"),
        SocialHistory: () => import("./social-history/social-history.vue"),
        PastMedicalHistory: () => import("./past-medical-history/past-medical-history.vue"),
        SurgicalHistory: () => import("./surgical-history/surgical-history.vue"),
        Allergies: () => import("./allergies/allergies.vue"),
        ObsGyn: () => import("./obs-gyn/obs-gyn.vue"),
        CurrentSymptoms: () => import("./current-symptoms/current-symptoms.vue"),
        MedicationHistory: () => import("./medication-history/medication-history.vue"),
    },
    i18n: {
        messages: {
            en: {
                ...localeEn
            },
            ar: {
                ...localeAr
            }
        },
    }
};